import { Response } from 'datx-jsonapi';

import { ResourceType } from '@/enums/ResourceType';
import { FETCH_NOTIFICATIONS_KEY } from '@/fetchers/notifications';
import { Notification } from '@/resources/Notification';

export const getKey = (index, previousPageData: Response<Notification>) => {
  if (previousPageData && !previousPageData?.links?.next) return null;

  if (index === 0) {
    return [null, FETCH_NOTIFICATIONS_KEY];
  }

  const previousNotifications = previousPageData?.data as Array<Notification>;

  return [previousNotifications[previousNotifications.length - 1].id, FETCH_NOTIFICATIONS_KEY];
};

export const getNotificationResourceLink = (eventId, notification) => {
  if (notification.resourceType === ResourceType.Lecture) {
    const isPoster = notification.lecture.posterDocument;

    return `/events/${eventId}/${isPoster ? 'posters' : 'sessions'}/${
      // we access eventSessionId in following way because we didn't want to include lecture.eventSession
      // to notifications request, since we just need id
      notification?.lecture?.meta?.refs?.eventSession
    }/${isPoster ? 'poster' : 'lecture'}/${notification.lecture.linkSlug}?notificationId=${notification.id}`;
  }

  return '';
};
